import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Get, Patch } from "libs/services";
import { setLoading } from "./loader";
import { StoreResponse } from "src/common/types/response/store";
import { MERCHANT } from "src/common/libs/config/merchant.config";
import { BaseResponse } from "src/common/types/response/BasePaginationResponse";
import { MerchantResponse } from "src/common/types/response/merchant";
import { reportLog } from "src/common/libs/utils/logs";

interface MerchantState {
  data?: StoreResponse;
  loading: boolean;
}

export const getMerchantDetail = createAsyncThunk(
  "merchant/getMerchantDetail",
  async ({ id }: { id: number }, thunkAPI) => {
    try {
      const query = {};
      const response = await Get<any>(`${MERCHANT.get}/${id}`, query);
      if (response.data.status) {
        return response.data;
      }
      return null;
    } catch (error) {
      reportLog({
        error: error,
        location: "features/merchant->getMerchantDetail",
        body: { id },
      });
      return null;
    } finally {
      thunkAPI.dispatch(setLoading(false));
    }
  }
);

export const updateMerchant = createAsyncThunk(
  "merchant/updateMerchant",
  async ({ body = {} }: { body: any }, { rejectWithValue }) => {
    try {
      const response = await Patch<BaseResponse<MerchantResponse>>(
        `${MERCHANT.patch}`,
        body
      );
      return response.data;
    } catch (error) {
      reportLog({
        error: error,
        location: "features/merchant->updateMerchant",
        body: { body },
      });
      // Pass the error to rejectWithValue
      return rejectWithValue(error);
    }
  }
);

const initialState: MerchantState = {
  data: null,
  loading: false,
};

export const merchantSlice = createSlice({
  name: "merchant",
  initialState,
  reducers: {
    clearData: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getMerchantDetail.pending, (state, action) => {
      state.data = null;
      state.loading = true;
    });
    builder.addCase(getMerchantDetail.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
    });
    builder.addCase(getMerchantDetail.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
    });
  },
});

export const { clearData } = merchantSlice.actions;

export default merchantSlice.reducer;
